module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_arrow_circle_right_gold-65a6a657684c68b53e14af591b4d995f.svg";